// extracted by mini-css-extract-plugin
export default {"box":"Emoji_box__33GAP","emoji":"Emoji_emoji__4i-7W","selected":"Emoji_selected__34RCq","number":"Emoji_number__oG361"};